import { hasCapability, type User } from "../base";
import { NON_EXISTENT_ID } from "../utils/types";
import { bidWhereUnique } from "./bid";

export const sowChangeWhere = (user: User) => {
  if (!hasCapability(user, "sowChange.read")) {
    return { AND: [{ id: NON_EXISTENT_ID }] };
  }
  return { bid: bidWhereUnique(user) };
};

export const sowChange = {
  read: (user: User) => hasCapability(user, "sowChange.read"),
  abandon: (user: User) => hasCapability(user, "sowChange.abandon"),
  updateBlockedProjects: (user: User) => hasCapability(user, "sowChange.updateBlockedProjects"),
};
